var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 10V19C24 21.76 21.76 24 19 24H5C2.24 24 0 21.76 0 19V8C0 5.24 2.24 3 5 3H13C13.55 3 14 3.45 14 4C14 4.55 13.55 5 13 5H5C3.85 5 2.86 5.65 2.35 6.59L9.88 14.12C11.05 15.29 12.95 15.29 14.12 14.12L17.94 10.3C18.33 9.91 18.96 9.91 19.35 10.3C19.74 10.69 19.74 11.32 19.35 11.71L15.53 15.53C14.56 16.5 13.27 16.99 11.99 16.99C10.71 16.99 9.43 16.5 8.45 15.53L2 9.07V19C2 20.65 3.35 22 5 22H19C20.65 22 22 20.65 22 19V10C22 9.45 22.45 9 23 9C23.55 9 24 9.45 24 10ZM16 4C16 1.79 17.79 0 20 0C22.21 0 24 1.79 24 4C24 6.21 22.21 8 20 8C17.79 8 16 6.21 16 4ZM18 4C18 5.1 18.9 6 20 6C21.1 6 22 5.1 22 4C22 2.9 21.1 2 20 2C18.9 2 18 2.9 18 4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.2cc6a957c67663a03cd894560eb7dfd6.svg";
export { ForwardRef as ReactComponent };